import { render, staticRenderFns } from "./colaboracion-justicia.vue?vue&type=template&id=82d7dcb6&lang=html&"
import script from "./colaboracion-justicia.vue?vue&type=script&lang=js&"
export * from "./colaboracion-justicia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports